module.exports = __webpack_public_path__ + "img/1f9fa.4e17bb0.svg";